var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { Query, pagination } from "@irati/utils/services/apollo";
import DealLocationQuery from "../../services/queries/DealLocations";
export var query = DealLocationQuery;
var DealLocationsQueryComponent = /** @class */ (function (_super) {
    __extends(DealLocationsQueryComponent, _super);
    function DealLocationsQueryComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealLocationsQueryComponent.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(Query, __assign({}, this.props), function (apolloState) {
            var fetchMore = function (variables) {
                return pagination({
                    query: query,
                    variables: variables
                }, apolloState);
            };
            return children(__assign(__assign({}, apolloState), { fetchMore: fetchMore }));
        }));
    };
    DealLocationsQueryComponent.defaultProps = {
        query: query,
        notifyOnNetworkStatusChange: true
    };
    return DealLocationsQueryComponent;
}(PureComponent));
export default DealLocationsQueryComponent;
